// Shared helper components for service pages

export function FitSection({ fitFor, notFor }) {
  return (
    <section className="svc-fit">
      <div className="wrap">
        <div className="svc-fit-grid">
          <div className="svc-fit-col svc-fit-yes reveal">
            <div className="svc-fit-head">
              <span className="svc-fit-mark svc-fit-mark-yes">✓</span>
              <span>מתאים ל</span>
            </div>
            <ul>{fitFor.map((f, i) => <li key={i} className="pre">{f}</li>)}</ul>
          </div>
          <div className="svc-fit-col svc-fit-no reveal">
            <div className="svc-fit-head">
              <span className="svc-fit-mark svc-fit-mark-no">×</span>
              <span>לא מתאים ל</span>
            </div>
            <ul>{notFor.map((f, i) => <li key={i} className="pre">{f}</li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FAQSection({ items, head = 'שאלות שמגיעות בכל שיחה' }) {
  return (
    <section className="svc-faq">
      <div className="wrap">
        <div className="svc-section-head reveal">
          <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>{head}</div>
          <h2 className="svc-h2">תשובות ישירות.</h2>
        </div>
        <div className="svc-faq-list">
          {items.map((f, i) => (
            <details key={i} className="svc-faq-item reveal">
              <summary>
                <span className="svc-faq-q">{f.q}</span>
                <span className="svc-faq-icon" aria-hidden="true">+</span>
              </summary>
              <div className="svc-faq-a pre">{f.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
